import { Component, OnInit, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { Assign } from 'utility-types';
import { BannerOptions } from '../banner/banner.component';
import { CheckboxGroupOptions } from '../checkbox-group/checkbox-group.component';
import { InfoOptions } from '../info/info.component';
import { ModalOpenerOptions } from '../modal-opener/modal-opener.component';
import { ReviewOptions } from '../review/review.component';
import { SelectOptions } from '../select/select.component';
import { TextInputOptions } from '../text-input/text-input.component';

@Component({
  selector: 'fieldset',
  templateUrl: './fieldset.component.html',
  styleUrls: ['./fieldset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldsetComponent implements OnInit {

  @Input() opener!: ModalOpenerOptions
  @Input() @HostBinding('class') classes!: string
  @Input() legend: string = ''
  @Input() set components(components: (Assign<Omit<TextInputOptions | SelectOptions | ReviewOptions, 'position'>, { inline: boolean }> | BannerOptions | InfoOptions | CheckboxGroupOptions )[]) {
    let start: number = 0
    this._components = components.map((current, index, components) => {
      if (current.type === 'intro-component') return { ...current }
      if (current.type === 'info-component') return { ...current }
      if (current.type === 'checkbox-group-component') return { ...current }
      if (!current.presence) return { ...current, position: 'fullwidth' }
      let next: { inline: boolean } | undefined
      for (let i = index + 1; i < components.length; i++) {
        const component = components[i]
        if (component.type === 'info-component') {
          if (component.presence) {
            next = { inline: false }
            break
          }
        } else if (component.type === 'intro-component') {
          next = { inline: false }
          break
        } else if (component.type === 'checkbox-group-component') {
          if (component.presence) {
            next = { inline: false }
            break
          }
        } else if (component.presence) {
          next = { inline: component.inline }
          break
        }
      }
      if (start === 0 && current.inline && next?.inline) {
        start = 0.5
        return { ...current, position: 'left' }
      }
      if (start === 0.5) {
        start = 0
        return { ...current, position: 'right' }
      }
      return { ...current, position: 'fullwidth' }
    })
  }

  _components: Array<any> = []

  constructor() { }

  ngOnInit(): void {
  }

  trackByFn(index: number, item: ComponentOptions) {
    return item.id
  }

}

export type ComponentOptions = TextInputOptions | SelectOptions | CheckboxGroupOptions